type Props = {
  icon: React.ElementType;
  iconWrapper: string;
  iconStyle: string;
  title: string;
  status: number;
};

export default function Index({
  icon: Icon,
  iconWrapper,
  iconStyle,
  title,
  status,
}: Props) {
  return (
    <div className="flex items-center gap-4">
      <div
        className={`w-12 h-12 rounded-full flex items-center justify-center ${iconWrapper}`}
      >
        <Icon className={`w-6 h-6 ${iconStyle}`} />
      </div>
      <div>
        <div className="text-sm text-gray-500 dark:text-gray-400">{title}</div>
        <div className="text-2xl font-bold text-gray-900 dark:text-white">
          {status}
        </div>
      </div>
    </div>
  );
}
